// Scrolls to either top, after prehead, after header to stay on the same header view
// scroll_behavior: smooth, instant, auto
export default (scroll_behavior = 'smooth') => {
  let scroll_to_y = 0;

  if (window.theme.breakpoints.current === 'mobile') {
    scroll_to_y = 0;
  } else {
    const main_nav = document.querySelector('.main-nav--desktop');
    const announcement_bar = document.querySelector('.announcement-bar--desktop');
    
    if (main_nav?.classList.contains('sticky')) {
      scroll_to_y = announcement_bar ? announcement_bar.offsetHeight : 0;
    }

    // Can't be after the header, tile scroll would be messed up
    // if ($('.main-nav--desktop').hasClass('header-hidden')) {
    //   scroll_to_y = ($('.announcement-bar--desktop').length) ? $('.main-nav--desktop').outerHeight() + $('.announcement-bar--desktop').outerHeight() : $('.main-nav--desktop').outerHeight();
    // }
  }

  // console.log(`--------------> Scroll to ${scroll_to_y}px`, $('.main-nav--desktop').hasClass('sticky'), $('.main-nav--desktop').hasClass('header-hidden'));

  window.scrollTo({
    top: scroll_to_y,
    behavior: scroll_behavior,
  });
};
